import { lazy } from "react";
import { Route, Redirect } from "wouter";
import type { RouteHelpers } from "./types";

const ContentHub = lazy(() => import("@/pages/ContentHub"));
const MediaLanding = lazy(() => import("@/pages/media/MediaLanding"));
const StorylinePage = lazy(() => import("@/pages/media/Storyline"));
const StorylinesPage = lazy(() => import("@/pages/media/Storylines"));
const Advertise = lazy(() => import("@/pages/media/Advertise"));
const CategoryLanding = lazy(() => import("@/pages/media/CategoryLanding"));
const DailyBrief = lazy(() => import("@/pages/media/DailyBrief"));
const TopicsHub = lazy(() => import("@/pages/media/TopicsHub"));
const Trending = lazy(() => import("@/pages/media/Trending"));
const NewsLanding = lazy(() => import("@/pages/media/NewsLanding"));
const NewsFeed = lazy(() => import("@/pages/media/NewsFeed"));
const FundingFeed = lazy(() => import("@/pages/media/FundingFeed"));
const ExecutiveMovesFeed = lazy(() => import("@/pages/media/ExecutiveMovesFeed"));
const VideoHub = lazy(() => import("@/pages/VideoHub"));
const VideoTopicPage = lazy(() => import("@/pages/VideoTopicPage"));
const VideoFormatPage = lazy(() => import("@/pages/VideoFormatPage"));
const Magazine = lazy(() => import("@/pages/Magazine"));
const ChiefInTechMagazine = lazy(() => import("@/pages/ChiefInTechMagazine"));
const MagazineIssue = lazy(() => import("@/pages/MagazineIssue"));
const MagazineReader = lazy(() => import("@/pages/MagazineReader"));
const FlipbookPage = lazy(() => import("@/pages/FlipbookPage"));
const ArticlePage = lazy(() => import("@/pages/ArticlePage"));

const MEDIA_SUBROUTES = new Set(["articles", "news", "daily-brief", "topics", "trending", "funding", "executive-moves", "advertise", "podcasts"]);

function MediaArticleGuardInner({ LazyRoute }: Pick<RouteHelpers, "LazyRoute">) {
    // This is rendered inside the /media/:id route — check segment to avoid conflicting with sub-pages
    return <LazyRoute component={ArticlePage} />;
}

export function MediaRoutes({ LazyRoute, MediaArticleGuard }: RouteHelpers) {
    return (
        <>
            {/* Media hub */}
            <Route path="/media/articles">{() => <LazyRoute component={ContentHub} />}</Route>
            <Route path="/media/daily-brief">{() => <LazyRoute component={DailyBrief} />}</Route>
            <Route path="/media/topics/:category">{() => <LazyRoute component={CategoryLanding} />}</Route>
            <Route path="/media/topics">{() => <LazyRoute component={TopicsHub} />}</Route>
            <Route path="/media/trending">{() => <LazyRoute component={Trending} />}</Route>
            <Route path="/media/news/industry-news">{() => <LazyRoute component={NewsFeed} />}</Route>
            <Route path="/media/news/funding">{() => <LazyRoute component={FundingFeed} />}</Route>
            <Route path="/media/news/executive-moves">{() => <LazyRoute component={ExecutiveMovesFeed} />}</Route>
            <Route path="/media/news">{() => <LazyRoute component={NewsLanding} />}</Route>
            <Route path="/media/funding">{() => <Redirect to="/media/news/funding" />}</Route>
            <Route path="/media/executive-moves">{() => <Redirect to="/media/news/executive-moves" />}</Route>
            <Route path="/media/advertise">{() => <LazyRoute component={Advertise} />}</Route>
            <Route path="/media/podcasts">{() => <Redirect to="/podcasts" />}</Route>
            <Route path="/media/:id">{() => <MediaArticleGuard />}</Route>
            <Route path="/media">{() => <LazyRoute component={MediaLanding} />}</Route>
            {/* Articles */}
            <Route path="/articles/:id">{() => <LazyRoute component={ArticlePage} />}</Route>
            <Route path="/articles">{() => <LazyRoute component={ContentHub} />}</Route>
            <Route path="/advertise">{() => <LazyRoute component={Advertise} />}</Route>
            {/* Videos */}
            <Route path="/videos/topic/:slug">{() => <LazyRoute component={VideoTopicPage} />}</Route>
            <Route path="/videos/format/:slug">{() => <LazyRoute component={VideoFormatPage} />}</Route>
            <Route path="/videos">{() => <LazyRoute component={VideoHub} />}</Route>
            {/* Magazine */}
            <Route path="/chief-in-tech-magazine">{() => <LazyRoute component={ChiefInTechMagazine} />}</Route>
            <Route path="/magazine/:slug/read">{() => <LazyRoute component={MagazineReader} />}</Route>
            <Route path="/magazine/:slug/flipbook">{() => <LazyRoute component={FlipbookPage} />}</Route>
            <Route path="/magazine/:slug">{() => <LazyRoute component={MagazineIssue} />}</Route>
            <Route path="/magazine">{() => <LazyRoute component={Magazine} />}</Route>
            {/* Storylines */}
            <Route path="/storylines/:slug">{() => <LazyRoute component={StorylinePage} />}</Route>
            <Route path="/storylines">{() => <LazyRoute component={StorylinesPage} />}</Route>
        </>
    );
}
